import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileViewModeBg from "../../assets/images&icons/bg-login.jpg";
import { axios } from '../..';
import EyeOpen from "../../components/Atomos/Icons/EyeOpen";
import EyeClosed from "../../components/Atomos/Icons/EyeClosed";

const ResetPasswordPage = () => {
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false);
  const [confirmPasswordTouched, setConfirmPasswordTouched] = useState<boolean>(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const navigate = useNavigate();
  const location = useLocation();
  const { userName, validationCode } = location?.state as { userName: string, validationCode: string };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newPassword = event.target.value;
    setNewPassword(newPassword);

    const isPasswordValid =
      newPassword.trim() === newPassword &&
      newPassword.length >= 8 &&
      /[A-Z]/.test(newPassword) &&
      /\d/.test(newPassword) &&
      /[!@#$%^&*(),.?":{}|<>]/.test(newPassword)

    setIsPasswordValid(isPasswordValid);
  };

  const handleConfirmPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPasswordTouched(true);
    const password = event.target.value;
    setConfirmPassword(password);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const numberCode = parseInt(validationCode);

      await axios.Post(`/password`, {
        userName,
        verificationCode: numberCode,
        password: newPassword,
        confirmPassword
      });
      navigate('/');
    } catch (error: any) {
      setErrorMessage(error.response.data.message || "Failed to reset password. Please try again.");
    }
  };

  return (
    <div className="min-h-[85vh] w-full max-w-md sm:max-w-lg md:w-[560px] flex flex-col justify-center items-center self-center">
      <div className={`flex w-full align-middle justify-center gap-28 px-5 py-4 bg-[#9C3325]`}>
        <h2 className={`text-center text-xl font-sans text-white roboto-font`}>RESET PASSWORD</h2>
      </div>
      <div className='bg-white w-full py-4'>
        <form className='text-black py-8 flex flex-col gap-4' onSubmit={handleSubmit}>
          <div className='w-full px-5'>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder='Enter New Password'
                value={newPassword}
                className="w-full p-2 border border-gray-300 rounded"
                onChange={handlePasswordChange}
              />
              {errorMessage && (
                <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
              )}
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOpen /> : <EyeClosed />}
              </button>
            </div>
            <ul className="text-left list-item text-[.75rem] mt-2">
              <li className={newPassword.length >= 8 ? 'text-green-500' : 'text-feedback-error'}>- Minimum 8 characters</li>
              <li className={/[A-Z]/.test(newPassword) ? 'text-green-500' : 'text-feedback-error'}>- At least 1 Capital Letter</li>
              <li className={/[a-z]/.test(newPassword) ? 'text-green-500' : 'text-feedback-error'}>- At least 1 Lowercase Letter</li>
              <li className={/\d/.test(newPassword) ? 'text-green-500' : 'text-feedback-error'}>- At least 1 number</li>
              <li className={/[!@#$%^&*(),.?":{}|<>]/.test(newPassword) ? 'text-green-500' : 'text-feedback-error'}>- At least 1 special character</li>
            </ul>
          </div>
          <div className='w-full px-5'>
            <div className="relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder='Confirm New Password'
                value={confirmPassword}
                className="w-full p-2 border border-gray-300 rounded"
                onChange={handleConfirmPasswordChange}
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <EyeOpen /> : <EyeClosed />}
              </button>
            </div>
            {confirmPasswordTouched && (
              newPassword !== '' && newPassword === confirmPassword ? (
                <span className="text-[.75rem] text-feedback-success">
                  Passwords match!
                </span>
              ) : (
                newPassword !== '' && (
                  <span className="text-[.75rem] text-feedback-error">
                    Passwords don't match
                  </span>
                )
              )
            )}
          </div>
          <button
            type="submit"
            disabled={!isPasswordValid || newPassword !== confirmPassword}
            className={`cursor-pointer w-11/12 text-white mx-auto flex text-center align-middle justify-center py-4 inter_font bg-[#BC3323] font-semibold text-[1rem] ${(!isPasswordValid || newPassword !== confirmPassword) ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            Reset Password
          </button>
        </form>

      </div>
    </div>
  );
}

export default ResetPasswordPage;
